<template>
  <div style="text-align: left">
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle">
      <div class="pop-area-dialog">
        <div class="left-content-box">
          <div class="search">
            <!--遮罩层 用于关闭搜索结果窗口-->
            <div v-show="showSearchResult" @click="showSearchResult = false" class="cover"></div>
            <label>
              <i class="el-icon-search search_s" v-show="search_isshow"></i>
              <input type="text" v-model="filterText" @focus="openSearchResult" />
              <i class="el-icon-search" v-show="!search_isshow"></i>
              <span v-show="!search_isshow">搜索成员、部门、员工ID</span>
            </label>
            <div v-show="showSearchResult" class="search-result">
              <!--空显示-->
              <div
                v-if="searchUserList.length === 0 && searchDepartmentList.length === 0"
                class="no-result"
              >
                没有搜索到结果
              </div>
              <div class="search-container" v-if="searchUserList.length !== 0">
                <div class="search-title">
                  <span>成员</span>
                  <el-button
                    type="text"
                    v-if="searchUserList.length > 3"
                    @click="fewUser = !fewUser"
                    style="color: #909399; font-weight: normal"
                  >
                    {{ fewUser ? '显示更多' : '收起' }}
                  </el-button>
                  <el-button v-else type="text" style="color: #909399; font-weight: normal">
                    已加载全部
                  </el-button>
                </div>
                <div v-for="user in searchResultUser" :key="user.userid" class="search-label">
                  <div class="search-label-left">
                    <span :title="user.name" style="width: 60px">{{ user.name }}</span>
                    <span :title="user.department" style="width: 155px; font-size: 14px">
                      {{ user.department }}
                    </span>
                  </div>
                  <div class="search-label-right">
                    <el-button
                      type="text"
                      :disabled="user.invalid === 1"
                      @click="addUserFromSearchResult(user)"
                    >
                      添加
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="search-container" v-if="searchDepartmentList.length !== 0">
                <div class="search-title">
                  <span>部门</span>
                  <el-button
                    type="text"
                    @click="fewDepartment = !fewDepartment"
                    v-if="searchDepartmentList.length > 3"
                    style="color: #909399; font-weight: normal"
                  >
                    {{ fewDepartment ? '显示更多' : '收起' }}
                  </el-button>
                  <el-button v-else type="text" style="color: #909399; font-weight: normal">
                    已加载全部
                  </el-button>
                </div>
                <div
                  v-for="department in searchResultDepartment"
                  :key="department.id"
                  class="search-label"
                >
                  <div class="search-label-left">
                    <span :title="department.name" style="width: 215px">{{ department.name }}</span>
                  </div>
                  <div class="search-label-right">
                    <el-button
                      type="text"
                      :disabled="department.invalid === 1"
                      @click="addDepartmentFromSearchResult(department)"
                    >
                      添加
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tree" v-loading="treeLoading">
            <el-tree
              ref="tree"
              :load="loadNode"
              :props="defaultProps"
              :expand-on-click-node="false"
              lazy
            >
              <div
                class="custom-tree-node"
                slot-scope="{ node, data }"
                @click="checkNode(node, data)"
              >
                <span
                  :title="data.name"
                  style="width: 180px"
                  v-html="data.name"
                  :style="{ color: data.invalid === 1 ? '#cbcbcb' : '' }"
                ></span>
                <span v-if="departIds.includes(data.id) || userIds.includes(data.userid)">
                  <i class="el-icon-check"></i>
                </span>
              </div>
            </el-tree>
          </div>
        </div>
        <div class="right-content-box">
          <div class="title-wrap">
            <span>已选择的成员、部门&nbsp;</span>
            <el-button
              slot="reference"
              type="text"
              class="blue-text-button"
              @click="clickChooseAll"
              v-if="false"
            >
              {{ !isChooseAll ? '全选' : '取消全选' }}
            </el-button>
            <el-button type="text" @click="clearSelection(true)">清空</el-button>
          </div>
          <div class="tag-content-area">
            <el-tag
              v-for="[key, value] in selectedDepartmentIds"
              :key="key"
              closable
              type="info"
              @close="closeDepartmentTag(key)"
              style="margin-right: 6px; margin-bottom: 10px"
            >
              <span v-html="value"></span>
            </el-tag>
            <el-tag
              v-for="[key, value] in selectedUserIds"
              :key="key"
              closable
              type="info"
              @close="closeUserTag(key)"
              style="margin-right: 6px; margin-bottom: 10px"
            >
              <span v-html="value"></span>
            </el-tag>
          </div>
        </div>
      </div>
      <div class="button-popup-footer">
        <el-button class="sort-btn cancel" @click="confirmTags(false)">取消</el-button>
        <el-button type="primary" class="sort-btn sure" @click="confirmTags(true)">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetWeComDepartmentById, GetWeComUserByName } from '@/api/addressList';
/**
 * selectViewRangeDialog组件
 * 用于选择人员和部门
 * 和selectViewRange的区别在于，dialog只有一个弹窗，没有回显，也不会在弹窗关闭后显示选择的内容，关闭弹窗即结束
 *
 * props：
 *  agentId：用于部门请求的企业应用id，默认为-1
 *  dialogTitle：dialog的标题文字
 *
 * methods：
 *  openDialog：打开dialog的方法
 *  closeDialog：关闭dialog的方法
 *  submitForm：用于获得最终的选择结果，返回人员id和部门id两个数组
 *  reloadTree：清空树并重新获取节点，会在agentId变更时自动调用，也可以手动调用
 *
 * event：
 *  submit：点击取消和确定后，触发submit事件，参数true/false（触发后不会自动关闭弹窗）
 */
const defaultAgentId = -1;
export default {
  name: 'SelectViewRange',
  props: {
    agentId: {
      type: Number,
      default: -1,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search_isshow: false,
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      visible: false,
      defaultValue: null,
      dialogVisible: false,

      departmentId: 0, // 当前正在查询的departmentId
      departmentInvalid: 1,

      filterText: '', // 搜索text
      fewUser: true, // 是否展示更少的搜索结果
      fewDepartment: true,
      searchUserList: [], // 搜索结果列表
      searchDepartmentList: [],

      searchTimer: null, // 搜索节流
      showSearchResult: false, // 搜索结果显示

      selectedDepartmentIds: new Map(),
      selectedUserIds: new Map(),

      trigger: false, // 用于触发vue刷新（map无法触发刷新）

      onLoadNode: false, // 用于保证同一时间只有一个loadNode在执行
      treeLoading: false,
    };
  },
  computed: {
    isChooseAll() {
      return false;
    },
    departIds() {
      // 用于tree判断节点是否已选
      // temp是为了触发vue刷新页面
      const temp = this.trigger;
      console.log(temp);
      return Array.from(this.selectedDepartmentIds.keys());
    },
    userIds() {
      // 用于tree判断节点是否已选
      // temp是为了触发vue刷新页面
      const temp = this.trigger;
      console.log(temp);
      return Array.from(this.selectedUserIds.keys());
    },
    hasSelection() {
      // 判断是否有选择
      const temp = this.trigger;
      console.log(temp);
      // console.log(Array.from(this.confirmUserIds.keys()).length);
      // console.log(Array.from(this.confirmDepartmentIds.keys()).length);
      return (
        Array.from(this.selectedUserIds.keys()).length +
          Array.from(this.selectedDepartmentIds.keys()).length !==
        0
      );
    },
    searchResultUser() {
      // 用于展开和收起，展示部分或全部搜索结果
      if (this.fewUser) {
        return this.searchUserList.slice(0, 3);
      }
      return this.searchUserList;
    },
    searchResultDepartment() {
      if (this.fewDepartment) {
        return this.searchDepartmentList.slice(0, 3);
      }
      return this.searchDepartmentList;
    },
  },
  watch: {
    filterText(val) {
      this.search_isshow = !!val;
      if (val) {
        this.searchName();
      } else {
        this.showSearchResult = false;
      }
    },
    agentId(val) {
      console.log('agent-id发生变化');
      this.agentId = val;
      this.reloadTree();
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    isChecked(node, data) {
      // 判断是否已经选择，用于显示☑️
      return this.selectedDepartmentIds.has(data.id) || this.selectedUserIds.has(data.userid);
    },
    loadNode(node, resolve) {
      // 用于tree的载入函数

      this.onLoadNode = true;
      if (node.level === 0) {
        this.treeLoading = true;
        this.departmentId = 0;
        this.nodeHead = node;
        this.resolveHead = resolve;
      } else {
        this.departmentId = node.data.id;
        this.departmentInvalid = node.data.invalid;
      }

      this.getDepartments().then((data) => {
        console.log(data);
        if (data) {
          for (const item of data.user_list) {
            item.leaf = true;
          }
          resolve([...data.department_list, ...data.user_list]);
        } else {
          resolve([]);
        }

        if (node.level === 0) {
          this.treeLoading = false;
        }
        this.onLoadNode = false;
      });
    },
    checkNode(node, data) {
      // 从树形结构添加选择
      console.log(node);

      if (data.invalid === 1) {
        this.$message.warning('所选对象已被禁用');
        return;
      }

      if (data.leaf) {
        // 个人 删除&添加
        if (this.selectedUserIds.has(data.userid)) {
          this.selectedUserIds.delete(data.userid);
        } else {
          this.selectedUserIds.set(data.userid, data.name);
        }
      } else {
        // 部门 删除&添加
        if (this.selectedDepartmentIds.has(data.id)) {
          this.selectedDepartmentIds.delete(data.id);
        } else {
          this.selectedDepartmentIds.set(data.id, data.name);
        }
      }
      this.triggerUpdate();
    },
    deb(fn, time) {
      // 防抖函数 用于搜索人员接口
      const clearTimer = function () {
        fn.call();
        this.searchTimer = null;
      };

      return () => {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
          this.searchTimer = null;
        }
        this.searchTimer = setTimeout(clearTimer, time);
      };
    },
    searchName() {
      // 搜索人员和部门
      const tempFun = this.deb(() => {
        if (this.filterText.length === 0 || this.filterText.match('^[ ]+$')) {
          // 避免发送为空的搜索请求
          return;
        }
        GetWeComUserByName({
          name: this.filterText,
          agent_id: this.agentId,
        })
          .then((res) => {
            console.log(res);
            this.searchUserList = res.user_detail_list || [];
            this.searchDepartmentList = res.department_detail_list || [];
            this.fewUser = true;
            this.fewDepartment = true;
            this.showSearchResult = true;
          })
          .catch((e) => {
            this.$message.error(e);
          });
      }, 300);
      tempFun();
    },
    addUserFromSearchResult(user) {
      // 从搜索结果添加人员
      if (this.selectedUserIds.has(user.userid)) {
        this.$message.warning(`已经添加了人员：${user.name}`);
      } else {
        this.selectedUserIds.set(user.userid, user.name);
        this.triggerUpdate();
      }
    },
    addDepartmentFromSearchResult(department) {
      // 从搜索结果添加部门
      if (this.selectedDepartmentIds.has(department.id)) {
        this.$message.warning(`已经添加了部门：${department.name}`);
      } else {
        this.selectedDepartmentIds.set(department.id, department.name);
        this.triggerUpdate();
      }
    },
    triggerUpdate() {
      // 触发vue更新，因为map类型限制
      this.trigger = !this.trigger;
      this.$forceUpdate();
    },
    reloadTree() {
      // 清空原有的树并重新加载
      console.log('清空树');
      const temp = setInterval(() => {
        if (!this.onLoadNode) {
          this.nodeHead.childNodes = [];
          this.loadNode(this.nodeHead, this.resolveHead); // 再次执行懒加载的方法
          // this.clearSelection(false); // 清空已有的选择
          // this.clearConfirmTags();
          clearInterval(temp);
        }
      }, 100);
    },
    clickChooseTags() {
      this.visible = !this.visible;
    },
    getDepartments() {
      // 请求部门树形结构
      return new Promise((resolve) => {
        GetWeComDepartmentById({
          agent_id: this.departmentInvalid === 0 ? defaultAgentId : this.agentId,
          department_id: this.departmentId,
          judge_status: 1,
        })
          .then((res) => {
            console.log(res);
            resolve(res);
          })
          .catch((e) => {
            this.$message.error(e);
            resolve();
          });
      });
    },
    clearSelection(showMessage) {
      // 清除所有选择，showMessage为是否展示提示
      this.selectedDepartmentIds.clear();
      this.selectedUserIds.clear();
      this.triggerUpdate();
      if (showMessage) {
        this.$message.success('清除成功！');
      }
    },
    // 内层删除tag
    closeUserTag(key) {
      this.selectedUserIds.delete(key);
      this.triggerUpdate();
    },
    closeDepartmentTag(key) {
      this.selectedDepartmentIds.delete(key);
      this.triggerUpdate();
    },
    openSearchResult() {
      // 点击输入框时显示上一次的搜索结果
      if (this.filterText.length) {
        this.showSearchResult = true;
      }
    },
    // 全选/取消全选
    clickChooseAll() {},
    // 确定修改
    confirmTags(confirm) {
      console.log(confirm);
      this.$emit('submitRange', confirm);
    },
    // 提交结果
    submitForm() {
      return {
        departIds: Array.from(this.selectedDepartmentIds.keys()),
        userIds: Array.from(this.selectedUserIds.keys()),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'index.scss';
</style>
